import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const GlobeIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" />
  </svg>
);

const BookIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
  </svg>
);

const UsersIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
  </svg>
);

const ArrowRightIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
  </svg>
);

const CheckIcon = () => (
  <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

const DualLanguagePage = () => {
  const eligibility = [
    'Spanish-speaking and entering Kindergarten through Second Grade',
    'English-speaking and entering Kindergarten through First Grade',
    'Bilingual in Spanish and English and entering Kindergarten through Second Grade',
  ];

  const enlTypes = [
    {
      title: 'Push-In',
      description:
        'An English as a New Language teacher works alongside a general education teacher to provide language and vocabulary support to students within their regular classroom.',
    },
    {
      title: 'Pull-Out',
      description:
        'English Language Learners who spend most of the school day in an English-only classroom are brought together for targeted, small-group instruction in English.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main id="main-content" className="pt-0">
        {/* Hero */}
        <section
          className="relative pt-36 pb-20 bg-[#00213a] overflow-hidden"
        >
          <div
            className="pointer-events-none absolute inset-x-0 bottom-0"
            style={{ height: '4rem', background: 'linear-gradient(to bottom, rgba(0,33,58,0) 0%, rgba(255,255,255,1) 100%)' }}
            aria-hidden="true"
          />

          <div className="max-w-6xl mx-auto px-6 lg:px-8 text-center">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
                <GlobeIcon />
                <span className="text-sm font-semibold text-white tracking-tight">
                  Academic Programs
                </span>
              </div>
            </div>
            <h1
              className="text-5xl lg:text-7xl font-semibold text-white mb-6 tracking-tight"
              style={{ letterSpacing: '-0.02em' }}
            >
              Dual Language Programs
            </h1>
            <p className="text-2xl text-white/90 font-normal max-w-3xl leading-relaxed mb-8 mx-auto">
              We offer families of English Language Learners two programs that
              help their children learn English — and keep their home language
              strong.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <a
                href="#visit"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white text-[#00213a] font-semibold rounded-lg hover:bg-gray-50 transition-all duration-200 shadow-sm"
              >
                Visit Us at PS 96 ACT <ArrowRightIcon />
              </a>
            </div>
          </div>
        </section>

        {/* Intro */}
        <section className="max-w-5xl mx-auto px-6 lg:px-8 mb-20 mt-12">
          <div className="bg-white border border-gray-200 rounded-xl shadow-md p-8 lg:p-12">
            <h2
              className="text-3xl font-semibold text-gray-900 mb-6 tracking-tight flex items-center gap-3"
              style={{ letterSpacing: '-0.02em' }}
            >
              <div className="w-12 h-12 rounded-lg bg-[#fdbb2e]/10 flex items-center justify-center text-[#00213a]">
                <BookIcon />
              </div>
              Two Pathways for English Language Learners
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                PS 96 offers families of English Language Learners two programs
                that support their children in learning English while growing
                as confident, literate speakers of their home language.
              </p>
              <p>
                Together, these programs build students who are{' '}
                <strong className="text-[#00213a]">
                  bilingual, biliterate, and bicultural
                </strong>{' '}
                — prepared for academic success and a lifetime of
                cross-cultural understanding.
              </p>
            </div>
          </div>
        </section>

        {/* Dual Language */}
        <section className="bg-gray-50 py-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="mb-10">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#fdbb2e]/5 rounded-lg border border-[#fdbb2e]/20 mb-4">
                <GlobeIcon />
                <span className="text-sm font-semibold text-[#00213a] tracking-tight">
                  Program 1
                </span>
              </div>
              <h2
                className="text-4xl font-semibold text-gray-900 mb-4 tracking-tight"
                style={{ letterSpacing: '-0.02em' }}
              >
                Dual Language
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl">
                Native English speakers and English Language Learners learn
                side by side, in both English and their home language.
              </p>
            </div>

            <div className="grid lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2 bg-white border border-gray-200 rounded-xl p-8">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  How It Works
                </h3>
                <div className="space-y-4 text-gray-700 leading-relaxed">
                  <p>
                    Dual Language programs include both native English speakers
                    and English Language Learners in the same classroom.
                    Students learn in both English and their home language.
                  </p>
                  <p>
                    In most Dual Language programs, students receive{' '}
                    <strong className="text-gray-900">
                      half of their instruction in their home language and the
                      other half in English
                    </strong>
                    .
                  </p>
                </div>
              </div>

              <div className="bg-[#00213a] text-white rounded-xl p-8">
                <div className="w-12 h-12 rounded-lg bg-white/20 flex items-center justify-center text-white mb-4">
                  <UsersIcon />
                </div>
                <h3 className="text-lg font-semibold mb-3">Program Goal</h3>
                <p className="text-white/90 leading-relaxed text-sm">
                  Students learn to <strong>speak, read, understand, and
                  write in two languages</strong> — while learning about and
                  appreciating other cultures.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Our Community */}
        <section className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#fdbb2e]/5 rounded-lg border border-[#fdbb2e]/20 mb-4">
                <UsersIcon />
                <span className="text-sm font-semibold text-[#00213a] tracking-tight">
                  Our Community
                </span>
              </div>
              <h2
                className="text-4xl font-semibold text-gray-900 mb-6 tracking-tight"
                style={{ letterSpacing: '-0.02em' }}
              >
                A Community of Many Cultures
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed text-lg">
                <p>
                  From kindergarten through sixth grade, students enrolled in
                  our Dual Language program learn in both Spanish and English.
                  Families from more than{' '}
                  <strong className="text-[#00213a]">15 countries</strong> make
                  up our unique community, which enhances the program and
                  cultivates a love of learning and an awareness for cultural
                  variety.
                </p>
                <p>
                  Recognizing the importance of students' languages, cultures,
                  and experiences for their academic development, the Dual
                  Language model has been a pillar of our school for many years.
                  Our students not only enhance their language skills but also
                  build strong, lifelong relationships while developing a shared
                  understanding of multicultural perspectives.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {[
                'IMG_9722.jpeg',
                'IMG_9724.jpeg',
                'IMG_3103.jpg',
                '98A7ACFC-E580-46DE-A668-D121587A2943.jpeg',
              ].map((file) => (
                <img
                  key={file}
                  src={`/assets/images/duallanguage/${file}`}
                  alt="Students in the PS 96 Dual Language program"
                  className="w-full h-48 lg:h-56 object-cover rounded-xl shadow-md"
                  loading="lazy"
                />
              ))}
            </div>
          </div>
        </section>

        {/* English as a New Language */}
        <section className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
          <div className="mb-10">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#fdbb2e]/5 rounded-lg border border-[#fdbb2e]/20 mb-4">
              <BookIcon />
              <span className="text-sm font-semibold text-[#00213a] tracking-tight">
                Program 2
              </span>
            </div>
            <h2
              className="text-4xl font-semibold text-gray-900 mb-4 tracking-tight"
              style={{ letterSpacing: '-0.02em' }}
            >
              English as a New Language (ENL)
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl">
              Teachers work with students to build speaking, writing, reading,
              and listening skills in English — with support in their home
              language.
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8">
            <p className="text-gray-700 leading-relaxed">
              In an English as a New Language program, teachers work with
              students to build their speaking, writing, reading and listening
              skills in English using supports in the students' home language.
              The goal of the program is to support students as they become
              capable in English.
            </p>
          </div>

          <h3 className="text-xl font-semibold text-gray-900 mb-6">
            Two ENL Program Models
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            {enlTypes.map((t) => (
              <div
                key={t.title}
                className="group bg-white border border-gray-200 rounded-xl p-8 hover:shadow-md hover:border-[#fdbb2e]/40 transition-all duration-200"
              >
                <div className="w-12 h-12 rounded-lg bg-[#fdbb2e]/10 flex items-center justify-center text-[#00213a] mb-4">
                  <BookIcon />
                </div>
                <h4 className="text-2xl font-semibold text-gray-900 mb-3">
                  {t.title}
                </h4>
                <p className="text-gray-700 leading-relaxed">{t.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Eligibility */}
        <section className="bg-gray-50 py-20">
          <div className="max-w-5xl mx-auto px-6 lg:px-8">
            <div className="bg-white border border-gray-200 rounded-xl p-8 lg:p-12">
              <div className="mb-8">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#00213a]/5 rounded-lg border border-[#00213a]/10 mb-4">
                  <UsersIcon />
                  <span className="text-sm font-semibold text-[#00213a] tracking-tight">
                    Who Should Apply
                  </span>
                </div>
                <h2
                  className="text-3xl font-semibold text-gray-900 mb-4 tracking-tight"
                  style={{ letterSpacing: '-0.02em' }}
                >
                  Is This Program Right for Your Child?
                </h2>
                <p className="text-gray-600 text-lg">
                  Our Dual Language program is designed for parents of children
                  who meet one of the following profiles:
                </p>
              </div>

              <ul className="space-y-4 mb-10">
                {eligibility.map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-3 bg-[#fdbb2e]/5 border border-[#fdbb2e]/20 rounded-lg p-4"
                  >
                    <div className="text-[#00213a] mt-0.5">
                      <CheckIcon />
                    </div>
                    <span className="text-gray-800 font-medium">{item}</span>
                  </li>
                ))}
              </ul>

              <div className="bg-[#00213a] rounded-xl p-8 text-white">
                <p className="text-lg leading-relaxed italic">
                  "You are a parent who wants to educate your child so that she
                  or he will become a{' '}
                  <strong className="text-[#fdbb2e]">
                    bilingual, biliterate, and bicultural person.
                  </strong>
                  "
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section id="visit" className="bg-[#00213a] py-20">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <h2
              className="text-4xl font-semibold text-white mb-6 tracking-tight"
              style={{ letterSpacing: '-0.02em' }}
            >
              Visit Us at PS 96 ACT
            </h2>
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Meet our team and see firsthand how a Dual Language education can
              enrich your child's future. We'd love to welcome your family to
              our classrooms.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="/#contact"
                className="inline-flex items-center gap-2 px-8 py-4 bg-white text-[#00213a] font-semibold rounded-lg hover:bg-gray-50 transition-all duration-200 shadow-sm"
              >
                Contact the School <ArrowRightIcon />
              </a>
              <a
                href="/directions"
                className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg border border-white/20 hover:bg-white/20 transition-all duration-200"
              >
                Directions &amp; Location
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default DualLanguagePage;
